import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAlertViewStore } from "../../components/common/store";
import LoadingButton from "../../AtomicComponents/LoadingButton"
import { login } from "../../services/AuthServices";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";



function SignIn() {
  const { showMsg } = useAlertViewStore();

  const baseUrl ="https://api.locationethiopia.com"

  const [showPassword, setShowPassword] = useState(false);
  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("");
  const [validation, setValidation] = useState({
    email: "",
    password: "",
  });
  const [language, setLanguage] = useState("en");


  const { t, i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage") || "en";
    i18n.changeLanguage(savedLanguage);
    setLanguage(savedLanguage);
  }, []);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    if (!email) errors.email = "Please enter an email";
    if (!password) errors.password = "Please enter password";

    if (Object.keys(errors).length > 0) {
      setValidation(errors);
      return;
    }

    setLoading(true);
    try {
      const data = await login(email, password);

      console.log("Login response:", data?.result);

      const token = localStorage.setItem("Finder-token", data?.result?.token);
      localStorage.setItem("name", data?.result?.user?.name);
      localStorage.setItem("avatar", data?.result?.user?.avatar || "");
      localStorage.setItem("userRole", data?.result?.user?.role || "");
      window.dispatchEvent(new Event("authChanged"));

      const role = data?.result?.user?.role
      console.log(role);

      if (role === 'admin' || role === 'agent') {
        navigate('/dashboard', { replace: true });
      } else {
        navigate('/home', { replace: true });
      }


      showMsg("Login Successfully", "success", 3);

    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message);
      showMsg(`Error: ${err.response?.data?.message}`, "error", 3);
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="h-full  flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">

        <div className="text-center mb-8">

          <h1 className="text-2xl font-bold text-gray-800 mb-5">{t('welcomeback')} </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <form className="space-y-6">

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('username')}
              </label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('enteryourusername')}
                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50 text-gray-900 placeholder-gray-500"
              />
              {validation.email && (
                <span className="text-sm text-red-500 block mt-1">
                  {validation.email}
                </span>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('password')}
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t('enteryourpassword')}
                  className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50 text-gray-900 placeholder-gray-500 pr-12"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                    </svg>
                  ) : (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"></path>
                    </svg>
                  )}
                </button>
              </div>
              {validation.password && (
                <span className="text-sm text-red-500 block mt-1">
                  {validation.password}
                </span>
              )}
            </div>



            {error && (
              <div className="text-center">
                <p className="text-sm text-red-500">{error}</p>
              </div>
            )}

            <LoadingButton
              onClick={handleSubmit}
              loading={loading}
              className="w-full px-3 py-2 bg-[#F06565] rounded-lg text-white active:bg-transparent active:border active:border-[#F06565] active:text-[#F06565]"
            >
              {t('login')}
            </LoadingButton>

            <div className="text-center">
              <Link
                to="/home/mobileAuth  "
                className="text-sm text-[#ef4444] hover:text-[#444444] hover:underline"
              >
                {t('signinwithmobilenumber')} 
              </Link>
            </div>

            {/* Forgot Password Link */}
            <div className="text-center">
              <Link
                to="/home/forgotPassword"
                className="text-sm text-[#ef4444] hover:text-[#444444] hover:underline"
              >
                {t('forgotpassword')} ?
              </Link>
            </div>
          </form>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-[#444444]">
            {t('Donthaveanaccount')} ?
            &nbsp;
            <Link to="/signup" className="text-[#ef4444] hover:text-[#444444] font-medium">
             {t('signup')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignIn;